import React from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import contactImg from '../assets/img/contact-img.svg'
import Email from '../assets/img/email.png'
import Mobile from '../assets/img/mobile.png'
import Validator from '../utils/Validator'
import { Alert } from 'react-bootstrap'
import { lang } from '../utils/functions'
import { createContact } from '../utils/groq'

/**
 * 
 * @param {Object} formData The object containing the pairs of field - value
 */
function validateInputs(formData) {
    const errors = []
    const toCheck = ['name', 'email', 'message']

    toCheck.forEach(field => {
        if (!Validator.isEmpty(formData[field])) {
            if (field === 'email' && !Validator.isEmail(formData[field])) {
                errors.push("l'adresse mail que vous avez saisie est incorrecte")
            }
        } else {
            errors.push(`le champ "${lang(field)}" ne doit pas être vide !`)
        }
    })
    return errors.join(' et ')
}

const Contact = () => {
    const formInitialDetails = {
        name: '',
        email: '',
        message: ''
    }

    const [formDetails, setFormDetails] = React.useState(formInitialDetails);
    const [buttonText, setButtonText] = React.useState('Envoyer')
    const [status, setStatus] = React.useState({})
    const [error, setError] = React.useState()

    const handleChange = React.useCallback(function (e) {
        const { name, value } = e.target
        setFormDetails({
            ...formDetails,
            [name]: value
        })
    }, [formDetails])

    const handleSubmit = async function (e) {
        e.preventDefault()
        setButtonText('Envoi en cour...')

        const errors = validateInputs(formDetails)

        if (errors) {
            setError(errors)
            setButtonText('Envoyer')
            return
        } else if (!errors && error) {
            setError()
        }

        formDetails._type = 'contact'
        
        await createContact(formDetails)
            .then(() => {
                setStatus({ success: true, message: 'Merci de rester en contact !😁🤗' })
            })
            .catch(error =>{ 
                setStatus({ success: false, message: 'Je suis désoler 😢 mais il semblerait que quelque chose ne va pas, pouvez-vous réessayez plus tard' })
                console.log(error)
            })

        setButtonText('Envoyer')
        setFormDetails(formInitialDetails)
    }

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <img src={contactImg} alt="Contact Us" data-zanim-lg='{"animation":"zoom-out","delay":0}' data-zanim-trigger="scroll" />
                    </Col>
                    <Col md={6}>
                        <h2 className="text-center">Entrons en contact</h2>

                        <div className="contact-cards">
                            <div className="contact-cards__item flex-wrap justify-content-center">
                                <img src={Email} alt="email me" />
                                <a className="text-dark" href="mailto:orlandoguicharddev@gmail.com">orlandoguicharddev@gmail.com</a>
                            </div>

                            <div className="contact-cards__item">
                                <img src={Mobile} alt="telephone me" />
                                <a className="text-dark" href="tel: +237 693886791">+237 693886791</a>
                            </div>
                        </div>
                        {error && <Alert variant='danger'> {error} </Alert>}
                        <form onSubmit={handleSubmit} method="POST">
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input type="text" name="name" required value={formDetails.name} placeholder="votre nom" onChange={handleChange} />
                                </Col>
                                
                                <Col sm={6} className="px-1">
                                    <input type="email" name="email" required value={formDetails.email} placeholder="votre adresse mail" onChange={handleChange} />
                                </Col>

                                <Col >
                                    <textarea name="message" required id="" rows="6" value={formDetails.message} placeholder="Votre Message" onChange={handleChange}></textarea>
                                    <button type="submit"><span>{buttonText}</span></button>
                                </Col>
                                <Col>
                                    {
                                        status.message &&
                                        <Col>
                                            <Alert variant={status.success === false ? 'danger' : 'success'}>{status.message}</Alert>
                                        </Col>
                                    }
                                </Col>
                            </Row>
                        </form>

                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default Contact;
